module.exports = "/_next/static/images/eu-ff9546c2e1d48e13fc8dad1b3c4656f4.svg";